<!-- <template>
    <div class="md-empty cms-use" :class="[theme,blockName]">
        cms-use md-empty md-team new-style4
        is empty
    </div>
</template> -->
<script>
import { h } from "vue";
export default {
    name: "MdEmpty",
    render(ctx) {
        const mdData = ctx.mdData || {};
        const moduleName = mdData.name;
        const blockName = ctx.$t(`module-name:module-name.${moduleName}`) || moduleName;
        let iconname = 'icon-drawar_02';
        const siteType = false;
        const noDataTip = siteType === 'SubSite' ? ''
            : ctx.$t('common:cmsPreview.doubleClickToConfigure', { blockName: blockName });
        return h('div', {
            class: `${moduleName} ${mdData.theme} cms-use md-empty`,
        }, [
            h('div', {
                class: `empty-content`
            },
            [
                h('span', {
                    class: `iconfont ${iconname} empty-img`
                }),
                h('i', ctx.$t('common:cmsPreview.noData') + '. ' + noDataTip)
            ])
        ]);

    }
}
</script>
<style  lang="scss">
.module-selected.md-empty {
    border: none;
}
.cms-use.md-empty {
    width: 100%;
    padding: 20px;
    text-align: center;
    overflow: hidden;
    background-color: var(--g-bg-color) !important;

    .empty-img {
        height: 28px;
        font-size: 28px;
        padding-bottom: 10px;
        color: var(--g-tip-color);
        display: block;
    }

    .empty-content {
        width: 100%;
        color: var(--g-tip-color);
        font-size: 14px;
        line-height: 20px;
        border: 1px dashed var(--g-tip-color);
        padding: 40px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}
</style>